// CSV downloads built in the browser from data a page already shows.

// Spreadsheets run a cell starting with one of these as a formula, so text
// cells get a leading apostrophe (OWASP "CSV injection").
const FORMULA_START = /^[=+\-@\t\r]/;

function csvCell(value) {
  if (value == null) return '';
  let text = String(value);
  if (typeof value === 'string' && FORMULA_START.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** CSV text from rows of cells; null cells are left empty. */
export function toCsv(rows) {
  return rows.map((row) => row.map(csvCell).join(',')).join('\n');
}

/**
 * File name from its parts, each lowercased and slugged (accents dropped),
 * joined by "_". Missing parts are skipped.
 * e.g. ['predico', 'Elia Solar', 'D+1'] -> 'predico_elia-solar_d+1.csv'
 */
export function csvFileName(parts) {
  const slugs = parts
    .map((part) => String(part ?? '')
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9+]+/g, '-')
      .replace(/^-+|-+$/g, ''))
    .filter(Boolean);
  return `${slugs.join('_')}.csv`;
}

/** Make the browser download `text` as the CSV file `fileName`. */
export function downloadCsv(fileName, text) {
  const url = URL.createObjectURL(new Blob([text], {type: 'text/csv;charset=utf-8'}));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
